
import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import RuleTabPanel from '@components/settings/rule/RuleTabPanel.vue';
import AppButton from '@components/new-styleguide/AppButton.vue';
import { Pilot, RuleV2Mutation, Tag } from '@clients/myTrips';
import PilotSelect from '@components/new-styleguide/form/PilotSelect.vue';
import TagSelect from '@components/new-styleguide/form/TagSelect.vue';
import { namespace } from 'vuex-class';

const SettingsModule = namespace('Settings');

@Component({
  name: 'RuleTabAction',
  components: {
    RuleTabPanel,
    AppButton,
    PilotSelect,
    TagSelect
  }
})
export default class RuleTabAction extends Vue {
  @Prop({ required: true })
  private value: RuleV2Mutation;

  @SettingsModule.Getter('getPilots')
  private pilots: Pilot[];

  @SettingsModule.Getter('getTags')
  private tags: Tag[];

  get pilot() {
    return this.value.pilotId && this.pilots.find(p => p.id === +this.value.pilotId);
  }

  get tag() {
    return this.value.tagId && this.tags.find(p => p.id === +this.value.tagId);
  }

  private handlePilotChange(p: Pilot) {
    this.input('pilotId', p ? String(p.id) : undefined);
  }

  private handleTagChange(t: Tag) {
    this.input('tagId', t ? String(t.id) : undefined);
  }

  private input(name: string, value) {
    const copy = {...this.value};

    copy[name] = value;

    this.$emit('input', copy);
  }

  private handleTextChange(text: string) {
    this.input('note', text);
  }

  private handleTextButtonChange(state: boolean) {
    this.input('work', state);
  }
}
